// Importer la fonction scrollToTarget du module animation.js
import { scrollToTarget } from "./modules/animation.js";

(function () {
  // Sélectionner les éléments du DOM
  const body = document.body;
  const tabLinkSelector = ".js-tabLink";
  const tabContents = document.querySelectorAll(".js-tabContent");
  const tabList = document.querySelector(".js-tabList");
  const tab = document.querySelectorAll(".js-tab");
  const DELAY_TIMEOUT = 600;

  // Fonction pour définir la hauteur maximale du parent des éléments
  function setParentMaxHeight(element) {
    let maxHeight = 0;

    // Trouver la hauteur maximale des éléments
    element.forEach((item) => {
      const paddingTop = parseInt(window.getComputedStyle(item).paddingTop, 10);
      const paddingBottom = parseInt(window.getComputedStyle(item).paddingBottom, 10);
      const itemHeight = item.clientHeight + paddingTop + paddingBottom;

      if (itemHeight > maxHeight) {
        maxHeight = itemHeight;
      }
    });

    // Définir la hauteur maximale des éléments sur leur parent
    element.forEach((item) => {
      item.parentElement.style.height = `${maxHeight}px`;
    });
  }

  // Fonction pour changer la couleur de fond de destination
  function changeBgColorDestination(element = null) {
    const dualBoxItemBgcolor = document.querySelector(".js-DualBox-item-bgcolor");

    if (dualBoxItemBgcolor) {
      if (element && element.dataset.destinationBgColor !== undefined && element.dataset.destinationBgColor) {
        dualBoxItemBgcolor.style.setProperty("--custom-bgc", element.dataset.destinationBgColor);
      } else {
        const currentTabLink = document.querySelector(".js-tabLink.is-current");
        if (currentTabLink && currentTabLink.parentElement.dataset.destinationBgColor) {
          dualBoxItemBgcolor.style.setProperty("--custom-bgc", currentTabLink.parentElement.dataset.destinationBgColor);
        } else if (dualBoxItemBgcolor.dataset.bgcolor) {
          dualBoxItemBgcolor.style.setProperty("--custom-bgc", dualBoxItemBgcolor.dataset.bgcolor);
        }
      }
    }
  }

  // Gestionnaire d'événement de chargement
  window.addEventListener("load", function () {
    setParentMaxHeight(tabContents);

    // Gestionnaire d'événement de redimensionnement
    window.addEventListener("resize", function () {
      setParentMaxHeight(tabContents);
    });

    // Gestionnaire d'événement mouseover sur le lien de l'onglet
    if (tabList) {
      tabList.addEventListener("mouseover", function (event) {
        const item = event.target.closest(tabLinkSelector);
        if (item) {
          const itemId = item.getAttribute("data-tab");
          const tabContentId = document.getElementById(itemId);

          // Nettoyer les autres temporisations
          clearTimeout(item.leaveHoverTimeout);

          item.hoverTimeout = setTimeout(function () {
            // GTM Tracking
            if (typeof gtm_datalayer_push === "function") {
              gtm_datalayer_push({
                event: "homepage_country_view",
                click_name: item.innerText,
                click_type: "hover",
              });
            }

            // Supprimer la classe "is-hover" de tous les éléments
            tabContents.forEach((content) => content.classList.remove("is-hover"));
            // Ajouter la classe "is-hover" aux éléments actuels
            tabContentId.classList.add("is-hover");
            tabContents.forEach((content) => content.parentElement.classList.add("is-hover"));

            // Changer la couleur de fond au survol
            changeBgColorDestination(item.parentElement);
          }, DELAY_TIMEOUT);
        }
      });

      tabList.addEventListener("mouseout", function (event) {
        const item = event.target.closest(tabLinkSelector);
        // Gestionnaire d'événement mouseleave sur le lien de l'onglet
        if (item) {
          const itemId = item.getAttribute("data-tab");
          const tabContentId = document.getElementById(itemId);

          // Nettoyer les autres temporisations
          clearTimeout(item.hoverTimeout);

          item.leaveHoverTimeout = setTimeout(function () {
            // Supprimer la classe "is-hover" de l'élément sur mouseout
            tabContentId.classList.remove("is-hover");
            tabContents.forEach((content) => content.parentElement.classList.remove("is-hover"));

            // Changer la couleur de fond au survol
            changeBgColorDestination(null);
          }, DELAY_TIMEOUT);
        }
      });
    }

    // Gestionnaire d'événement click pour ajouter une classe aux éléments actuels et faire défiler vers la cible
    document.querySelectorAll(tabLinkSelector).forEach((tabLink) => {
      tabLink.addEventListener("click", function (event) {
        const item = event.target.closest(tabLinkSelector);
        if (item) {
          const parent = item.closest(".js-tab");
          const itemId = item.getAttribute("data-tab");
          const tabContentId = document.getElementById(itemId);

          // Supprimer les classes "is-active", "is-current", "is-hover" des éléments actuels
          tab.forEach((tabItem) => tabItem.classList.remove("is-active"));
          document.querySelectorAll(tabLinkSelector).forEach((link) => link.classList.remove("is-current"));
          tabContents.forEach((content) => content.classList.remove("is-current"));
          tabContents.forEach((content) => content.parentElement.classList.remove("is-hover"));

          // Ajouter les nouvelles classes aux éléments actuels
          parent.classList.add("is-active");
          item.classList.add("is-current");
          tabContentId.classList.add("is-current");

          // GTM Tracking
          if (typeof gtm_datalayer_push === "function") {
            gtm_datalayer_push({
              event: "homepage_country_click",
              click_name: item.innerText,
              click_type: "hover",
            });
          }

          // Changer la couleur de fond au clic
          changeBgColorDestination(parent);

          // Faire défiler jusqu'à la cible et soustraire la hauteur du menu
          scrollToTarget(".js-scrollToTarget", NAVBAR, FIXEDNAV);

          event.preventDefault();
          event.stopPropagation();
        }
      });
    });
  });
})();
